/**
 * Viewports con ancho <= este valor (px): menú hamburguesa, sidebar en overlay,
 * layouts compactos en agenda y botón de resumen en Titulo (celular + tablet).
 */
export const LAYOUT_COMPACT_MAX_PX = 1024;
